import { blue, green, grey } from "@mui/material/colors";

const lightVariant = {
  name: "Light",
  palette: {
    primary: {
      //main: "#8bc53F",
      main: "#F00",
      contrastText: "#FFF",
    },
    secondary: {
      main: "#aaa",
      contrastText: "#444",
    },
  },
  header: {
    color: grey[500],
    background: "#FFFFFF",
    search: {
      color: grey[800],
    },
    indicator: {
      background: blue[600],
    },
  },
  sidebar: {
    color: grey[200],
    background: "#1B2430",
    header: {
      color: grey[200],
      background: "#232f3e",
      brand: {
        color: blue[500],
      },
    },
    footer: {
      color: grey[200],
      background: "#232f3e",
      online: {
        background: green[500],
      },
    },
    badge: {
      color: "#FFF",
      background: blue[500],
    },
  },
  body: {
    background: "#fff",
  },
};

const darkVariant = {
  name: "Light",
  palette: {
    primary: {
      //main: "#8bc53F",
      main: "#F00",
      contrastText: "#FFF",
    },
    secondary: {
      main: "#DEDEDE",
      contrastText: "#444",
    },
  },
  header: {
    color: grey[500],
    background: "#FFFFFF",
    search: {
      color: grey[800],
    },
    indicator: {
      background: blue[600],
    },
  },
  sidebar: {
    color: grey[200],
    background: "#1B2430",
    header: {
      color: grey[200],
      background: "#232f3e",
      brand: {
        color: blue[500],
      },
    },
    footer: {
      color: grey[200],
      background: "#232f3e",
      online: {
        background: green[500],
      },
    },
    badge: {
      color: "#FFF",
      background: blue[500],
    },
  },
  body: {
    background: "#000",
  },
};

const createLightVariant = (primaryColor) => {
  return {
    ...lightVariant,
    palette: {
      ...lightVariant.palette,
      primary: {
        main: primaryColor,
        contrastText: "#FFF",
      },
    },
  };
};

const createDarkVariant = (primaryColor) => {
  return {
    ...darkVariant,
    palette: {
      ...darkVariant.palette,
      primary: {
        main: primaryColor,
        contrastText: "#FFF",
      },
    },
  };
};

export const createVariant = (primaryColor, isDarkTheme) => {
  return isDarkTheme
    ? createDarkVariant(primaryColor)
    : createLightVariant(primaryColor);
};
